import { useSuspenseQuery } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useDocumentClassifications({ documentKey }: { documentKey: string }) {
  return useSuspenseQuery({
    ...apiClient.getDocumentClassificationDocumentsKeyClassificationsGetOptions({
      path: {
        key: documentKey,
      },
    }),
  })
}
